import React, { Component, Fragment } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import AppURL from '../../api/AppURL';
import axios from 'axios'
import ReactHtmlParser from 'html-react-parser';
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Link } from 'react-router-dom';

class About extends Component {


     // mainDiv: এটি state এর একটি প্রপার্টি,
     // "d-none": এটি সাধারণত Bootstrap-এর একটি CSS ক্লাস, যা এলিমেন্টকে display: none; করে লুকিয়ে রাখে। 
     // অর্থাৎ, যখন "d-none" ক্লাস কোনো HTML এলিমেন্টে প্রয়োগ করা হয়, তখন সেই এলিমেন্টটি পেজে দেখা যাবে না।
     // কম্পোনেন্ট লোড হওয়ার সময় mainDiv লুকানো থাকে (কারণ d-none সেট করা আছে), 
     // এবং পরে এটি দৃশ্যমান করতে প্রয়োজন অনুযায়ী mainDiv এর মান পরিবর্তন করা হয়।
     // loaderDiv: এটি state এর একটি প্রপার্টি,loaderDiv: এটি state এর একটি প্রপার্টি, যা কম্পোনেন্টে লোডিং অবস্থার জন্য ব্যবহৃত হয়।
     // এই প্রপার্টির মূল উদ্দেশ্য হলো লোডিং অবস্থায় কিছু দেখানো বা লুকানো। 
     // উদাহরণস্বরূপ, API কল করার সময় ডাটা লোড হওয়া পর্যন্ত লোডার দেখাতে এই প্রপার্টি পরিবর্তন করা হতে পারে।
     //<div className={this.state.loaderDiv}>
     //লোডিং হচ্ছে...
     //</div>

     constructor() {
          super();
          this.state = {
               about: "",
               loaderDiv: "",
               mainDiv: "d-none"
          }
     }

     componentDidMount() {
          axios.get(AppURL.AllSiteInfo).then(response => {
               let StatusCode = response.status;
               if (StatusCode == 200) {

                    //এখানে response.data একটি অ্যারের মতো স্ট্রাকচারে আছে ধরে নেওয়া হচ্ছে।
                    //যেহেতু response.data একটি অ্যারে, তাই এর প্রথম আইটেমটি [0] ইন্ডেক্সের মাধ্যমে অ্যাক্সেস করা হচ্ছে। 
                    //এটি [0] প্রথম ডেটা অবজেক্ট, যেখানে about নামের একটি প্রপার্টি আছে।
                    let JsonData = (response.data)[0]['about'];
                    this.setState({ about: JsonData, loaderDiv: "d-none", mainDiv: "" });
               }

          }).catch(error => {

          });
     }




     render() {
          return (
               <Fragment>
                    <Container>


                         {/* Breadcrumb একটি নেভিগেশন উপাদান যা ব্যবহারকারীদের ওয়েবসাইটের বিভিন্ন স্তরে অবস্থান বুঝতে এবং বিভিন্ন পেজে সহজেই নেভিগেট বা চলাচল করতে সাহায্য করে।  */}
                         <div className="breadbody">
                              <Breadcrumb>
                                   <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
                                   <Breadcrumb.Item> <Link to="/about"> About </Link> </Breadcrumb.Item>
                              </Breadcrumb>
                         </div>




                         <Row className="p-2">
                              <Col className="shadow-sm bg-white mt-2" md={12} lg={12} sm={12} xs={12}>

                                   <div className={this.state.loaderDiv}>

                                        <div class="ph-item">
                                             <div class="ph-col-12">
                                                  <div class="ph-row">
                                                       <div class="ph-col-4"></div>
                                                       <div class="ph-col-8 empty"></div>
                                                       <div class="ph-col-6"></div>
                                                       <div class="ph-col-6 empty"></div>
                                                       <div class="ph-col-12"></div>
                                                       <div class="ph-col-12"></div>
                                                       <div class="ph-col-12"></div>
                                                       <div class="ph-col-12"></div>
                                                  </div>
                                             </div>
                                        </div>


                                        <div class="ph-item">
                                             <div class="ph-col-12">
                                                  <div class="ph-row">
                                                       <div class="ph-col-4"></div>
                                                       <div class="ph-col-8 empty"></div>
                                                       <div class="ph-col-6"></div>
                                                       <div class="ph-col-6 empty"></div>
                                                       <div class="ph-col-12"></div>
                                                       <div class="ph-col-12"></div>
                                                       <div class="ph-col-12"></div>
                                                       <div class="ph-col-12"></div>
                                                  </div>
                                             </div>
                                        </div>

                                   </div>

                                   <div className={this.state.mainDiv}>

                                        <h4 className="section-title-login">About Us Page </h4>
                                        <p className="section-title-contact">

                                             {/* ReactHtmlParser: এটি একটি লাইব্রেরি যা HTML ট্যাগসমূহকে React কম্পোনেন্টে রূপান্তর করতে ব্যবহৃত হয়। 
                                             
                                             ReactHtmlParser(this.state.about): এখানে this.state.about এর ভেতরের HTML ট্যাগগুলো পার্স করা হচ্ছে, 
                                             যাতে <p className="section-title-contact"> এর ভেতরে
                                             
                                             */}
                                             {ReactHtmlParser(this.state.about)}
                                        </p>

                                   </div>


                              </Col>
                         </Row>
                    </Container>
               </Fragment>
          )
     }
}

export default About
